<template>
    <div v-if="!loadingPage" class="pb-2">
        <div class="d-flex justify-content-between align-items-center">
            <h3 class="text-primary mb-2">فاکتور انبار</h3>
            <div v-if="isAdminIdentityVerified" class="d-flex justify-content-md-end justify-content-center mb-2">
                <b-button @click="showModalCreate" :disabled="!materials.length || !people.length || !warehouses.length"
                    variant="primary" class="px-2">
                    ثبت فاکتور انبار
                </b-button>
            </div>
        </div>
        <div v-if="isAdminIdentityVerified">
            <b-row class="mb-2 mb-md-50">
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="نوع فاکتور" label-for="typeId">
                        <v-select v-model="parameters.type" :searchable="false" id="typeId" dir="rtl"
                            :options="typeParameter" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="تاریخ شروع" label-for="fromId">
                        <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                            :value="parameters.fromDate ? formatDate(parameters.fromDate) : null" autocomplete="off"
                            name="fromId" />
                        <date-picker v-model="parameters.fromDate" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="تاریخ پایان" label-for="toId">
                        <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                            :value="parameters.toDate ? formatDate(parameters.toDate) : null" autocomplete="off" />
                        <date-picker v-model="parameters.toDate" :max="currentDate" format="YYYY-MM-DD"
                            display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="شخص" label-for="personId">
                        <v-select v-model="parameters.personId" :searchable="false" id="personId" dir="rtl"
                            :options="personParameter" autocomplete="off" class="bg-white" style="border-radius: 6px;"
                            :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="انبار مبدأ" label-for="sourceWarehouseId">
                        <v-select v-model="parameters.sourceWarehouseId" :searchable="false" id="sourceWarehouseId"
                            dir="rtl" :options="warehouseParameter" autocomplete="off" class="bg-white"
                            style="border-radius: 6px;" :reduce="(value) => value.id" label="name" :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-25">
                    <b-form-group label="انبار مقصد" label-for="destinationWarehouseId">
                        <v-select v-model="parameters.destinationWarehouseId" :searchable="false"
                            id="destinationWarehouseId" dir="rtl" :options="warehouseParameter" autocomplete="off"
                            class="bg-white" style="border-radius: 6px;" :reduce="(value) => value.id" label="name"
                            :clearable="false">
                            <template #no-options>
                                موردی وجود ندارد
                            </template>
                        </v-select>
                    </b-form-group>
                </b-col>
                <b-col lg="3" md="3" class="mt-md-2 mt-50">
                    <b-button variant="secondary" class="w-100 mt-md-25 mt-0" @click="removeFilters"
                        :disabled="loading">
                        حذف فیلتر ها
                    </b-button>
                </b-col>
                <b-col lg="3" md="3" class="mt-md-2 mt-50">
                    <b-button variant="info" @click="getWarehousingInvoices" :disabled="loading"
                        class="mt-25 d-flex justify-content-center w-100">
                        <span>اعمال فیلتر</span>
                        <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
            <b-card class="p-0" no-body>
                <b-overlay v-if="invoices.length" :show="loading" variant="transparent" opacity="1" blur="3px"
                    rounded="sm">
                    <b-table responsive :items="invoices" :fields="fields" class="mb-0" striped>
                        <template #cell(details)="data">
                            <b-spinner v-if="loadingbuttons[data.index]" variant="info" small></b-spinner>
                            <feather-icon v-else @click="showDetails(data.item.id, data.index)" size="20"
                                icon="InfoIcon" class="pointer text-info" color="#8d88a3" />
                        </template>
                        <template #cell(type)="data">
                            {{ type_management(data.item.type) }}
                        </template>
                        <template #cell(person)="data">
                            {{ data.item.person.name }}
                        </template>
                        <template #cell(sourceWarehouse)="data">
                            {{ data.item.sourceWarehouse ? data.item.sourceWarehouse.name : '-' }}
                        </template>
                        <template #cell(destinationWarehouse)="data">
                            {{ data.item.destinationWarehouse ? data.item.destinationWarehouse.name : '-' }}
                        </template>
                        <template #cell(createdBy)="data">
                            {{ `${data.item.createdBy.firstName} ${data.item.createdBy.lastName}` }}
                        </template>
                        <template #cell(createdAt)="data">
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new
                                    Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                        2).join(":") }}
                            </span>
                        </template>
                    </b-table>
                </b-overlay>
                <div v-else class="text-center py-5">
                    موردی وجود ندارد
                </div>
            </b-card>
            <b-pagination align="center" @input="getWarehousingInvoices" v-model="parameters.pageIndex"
                :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
        </div>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

        <!------------------------------- modal create ------------------------------->
        <b-modal id="warehousing-invoices" title="ثبت فاکتور" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <validation-observer ref="warehousingInvoicesValidation">
                <b-form @submit.prevent class="px-1 pb-1">
                    <b-row v-for="(item, index) in formItems" :key="`item_${index}`" class="pt-1 pb-50"
                        :class="{ 'border-top': index !== 0 }">
                        <b-col xl="6" lg="6">
                            <b-form-group label="ماده اولیه (کالا)">
                                <validation-provider #default="{ errors }" name="ماده اولیه" rules="required"
                                    :vid="`rawMaterial_${index}`">
                                    <v-select v-model="item.rawMaterial" :searchable="false" dir="rtl"
                                        @input="item.displayUnit = item.rawMaterial.unit" :reduce="(value) => value"
                                        class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                        style="border-radius: 6px;" label="name" :clearable="false"
                                        :options="materials">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="6" lg="6">
                            <b-form-group label="واحد اندازه‌گیری">
                                <validation-provider #default="{ errors }" name="واحد اندازه‌گیری" rules="required"
                                    :vid="`displayUnit_${index}`">
                                    <v-select v-model="item.displayUnit" :searchable="false" dir="rtl"
                                        :disabled="!item.rawMaterial" :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="getUnits(item.rawMaterial)">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="مقدار">
                                <validation-provider #default="{ errors }" name="مقدار" rules="required"
                                    :vid="`quantity_${index}`">
                                    <b-form-input dir="ltr" type="number" v-model="item.quantity" inputmode="numeric"
                                        :class="errors.length > 0 ? 'border-danger' : null" autocomplete="off"
                                        class="text-center"></b-form-input>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="3" lg="3">
                            <b-form-group label="فی (ریال)" label-for="unitPriceId">
                                <validation-provider #default="{ errors }" name="فی" rules="required"
                                    :vid="`unitPrice_${index}`">
                                    <cleave id="unitPriceId" dir="ltr" v-model="item.unitPrice" autocomplete="off"
                                        inputmode="numeric" class="form-control text-center user-select-none mt-75"
                                        :options="options.number" :class="errors.length > 0 ? 'border-danger' : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col xl="4" lg="4">
                            <div>
                                <div>مبلغ کل (ریال)</div>
                                <div class="border rounded mt-50 p-50 text-center">
                                    {{ (item.unitPrice * item.quantity).toLocaleString('fa-IR') }}
                                </div>
                            </div>
                        </b-col>
                        <b-col xl="2" lg="2" class="mt-2 pt-0 pt-lg-25">
                            <b-button variant="danger" @click="deleteRawMaterialItems(item)" class="w-100"
                                :disabled="formItems.length == 1">
                                <feather-icon icon="Trash2Icon" size="18" />
                            </b-button>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-between align-items-center mt-50 pb-50">
                        <div class="d-flex align-items-center">
                            <div>جمع کل :</div>
                            <div class="d-flex align-items-center ml-25 pt-25">
                                <h3 class="mb-0">{{ totalInvoiceAmount.toLocaleString('fa-IR') }}</h3>
                                <h5 class="mb-0 ml-25">ریال</h5>
                            </div>
                        </div>
                        <b-button variant="info" @click="addRawMaterialItems">
                            اضافه کردن
                        </b-button>
                    </div>
                    <hr>
                    <b-row class="mt-2">
                        <!------------ type ------------>
                        <b-col md="6">
                            <b-form-group label="نوع فاکتور" label-for="typeId" class="text-center">
                                <validation-provider #default="{ errors }" name="نوع فاکتور" rules="required">
                                    <v-select v-model="form.type" :searchable="false" dir="rtl"
                                        :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="typemanagement">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!------------ invoiceMode ------------>
                        <b-col md="6">
                            <b-form-group label="نوع عملیات" label-for="invoiceModeId" class="text-center">
                                <validation-provider #default="{ errors }" name="نوع عملیات" rules="required">
                                    <v-select v-model="invoiceMode" :searchable="false" dir="rtl"
                                        :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="invoiceModemanagement">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!------------ sourceWarehouseId ------------>
                        <b-col md="6">
                            <b-form-group label="انبار مبدأ" label-for="sourceWarehouseId" class="text-center">
                                <validation-provider #default="{ errors }" name="انبار مبدأ"
                                    :rules="form.type == 1 || invoiceMode == 1 ? 'required' : ''">
                                    <v-select v-model="form.sourceWarehouseId" :searchable="false" dir="rtl"
                                        :disabled="form.type == 0 && invoiceMode == 0" :reduce="(value) => value.id"
                                        class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                        style="border-radius: 6px;" label="name" :clearable="false"
                                        :options="warehouses">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!------------ destinationWarehouseId ------------>
                        <b-col md="6">
                            <b-form-group label="انبار مقصد" label-for="destinationWarehouseId" class="text-center">
                                <validation-provider #default="{ errors }" name="انبار مقصد"
                                    :rules="form.type == 0 || invoiceMode == 1 ? 'required' : ''">
                                    <v-select v-model="form.destinationWarehouseId" :searchable="false" dir="rtl"
                                        :disabled="form.type == 1 && invoiceMode == 0" :reduce="(value) => value.id"
                                        class="bg-white" :class="errors.length > 0 ? 'border-danger' : null"
                                        style="border-radius: 6px;" label="name" :clearable="false"
                                        :options="warehouses">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>


                        <!------------ personId ------------>
                        <b-col md="6">
                            <b-form-group label="شخص" label-for="personId" class="text-center">
                                <validation-provider #default="{ errors }" name="شخص" rules="required">
                                    <v-select v-model="form.personId" :searchable="false" dir="rtl"
                                        :reduce="(value) => value.id" class="bg-white"
                                        :class="errors.length > 0 ? 'border-danger' : null" style="border-radius: 6px;"
                                        label="name" :clearable="false" :options="people">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>

                        <!-- externalInvoiceCode -->
                        <b-col md="6">
                            <b-form-group label="شناسه فاکتور" label-for="externalInvoiceCodeId" class="text-center">
                                <b-form-input autocomplete="off" dir="ltr" id="externalInvoiceCodeId"
                                    v-model="form.externalInvoiceCode" name="externalInvoiceCode"
                                    class="text-center user-select-none" />
                            </b-form-group>
                        </b-col>

                        <!-- date -->
                        <b-col md="6">
                            <b-form-group label="تاریخ فاکتور" label-for="dateId" class="text-center">
                                <b-form-input id="dateId" class="text-center main-input font-weight-bolder pointer"
                                    autocomplete="off"
                                    :value="form.date ? new Date(form.date).toLocaleDateString('fa-IR') : null"
                                    name="dateId" />
                            </b-form-group>
                            <date-picker v-model="form.date" :max="currentDate" format="YYYY-MM-DD"
                                display-format="jYYYY-jMM-jDD" custom-input="#dateId" />
                        </b-col>

                        <!-- tax -->
                        <b-col md="6">
                            <b-form-group label="مالیات (ریال)" label-for="taxId" class="text-center">
                                <cleave id="taxId" dir="ltr" v-model="form.tax" autocomplete="off"
                                    class="form-control text-center user-select-none" :options="options.number" />
                            </b-form-group>
                        </b-col>

                        <!-- shipping -->
                        <b-col md="6">
                            <b-form-group label="حمل و نقل (ریال)" label-for="shippingId" class="text-center">
                                <cleave id="shippingId" dir="ltr" v-model="form.shipping" autocomplete="off"
                                    class="form-control text-center user-select-none" :options="options.number" />
                            </b-form-group>
                        </b-col>

                        <!-- discount -->
                        <b-col md="6">
                            <b-form-group label="تخفیف (ریال)" label-for="discountId" class="text-center">
                                <cleave id="discountId" dir="ltr" v-model="form.discount" autocomplete="off"
                                    class="form-control text-center user-select-none" :options="options.number" />
                            </b-form-group>
                        </b-col>

                        <!-- description -->
                        <b-col md="12">
                            <b-form-group label="توضیحات" label-for="descriptionId" class="text-center">
                                <b-form-textarea rows="2" no-resize autocomplete="off" dir="rtl" id="descriptionId"
                                    v-model="form.description" name="description"></b-form-textarea>
                            </b-form-group>
                        </b-col>

                        <b-col md="12">
                            <b-button type="submit" variant="primary" @click="createWarehousingInvoices"
                                :disabled="loadingButton"
                                class="w-100 mt-75 d-flex align-items-center justify-content-center">
                                <b-spinner v-if="loadingButton" class="mr-50" variant="white" small></b-spinner>
                                <span>ثبت فاکتور</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </validation-observer>
        </b-modal>

        <!------------------------------- modal warehousing invoices detail ------------------------------->
        <b-modal id="warehousing-invoices-detail" title="جزئیات فاکتور انبار" centered :hide-footer="true"
            title-class="font-weight-bolder" size="lg">
            <warehouseInvoiceDetail :invoiceDetails="invoiceDetails" />
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BFormTextarea, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';
import vSelect from 'vue-select';
import warehouseInvoiceDetail from '@/@core/components/warehouse-invoice-detail/index.vue';
import Cleave from 'vue-cleave-component'
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        Cleave,
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BFormTextarea,
        BBadge,
        vSelect,
        warehouseInvoiceDetail
    },
    computed: {
        type_management() {
            return (status) => {
                if (status == 0) {
                    return 'فاکتور خرید'
                }
                if (status == 1) {
                    return 'فاکتور فروش'
                }
            }
        },
        totalInvoiceAmount() {
            return this.formItems.reduce((sum, item) => {
                const unitPrice = Number(item.unitPrice) || 0
                const quantity = Number(item.quantity) || 0
                return sum + (unitPrice * quantity)
            }, 0)
        },
        getUnits() {
            return (rawMaterial) => {
                if (!rawMaterial) return [];
                if (rawMaterial.unit === 1) return this.unitKilogram;
                if (rawMaterial.unit === 2) return this.unitLiter;
                return this.unitNumber;
            }
        },
    },
    mixins: [accessHandling],
    data() {
        return {
            required,
            loadingPage: true,
            loading: false,
            loadingbuttons: [],
            loadingButton: false,
            isAdminIdentityVerified: false,
            people: [],
            personParameter: [],
            materials: [],
            warehouses: [],
            warehouseParameter: [],
            invoices: [],
            invoiceDetails: {},
            currentDate: '',
            options: {
                number: {
                    numeral: true,
                    numeralThousandsGroupStyle: 'thousand',
                },
            },
            unitKilogram: [
                {
                    name: 'گرم',
                    id: 1,
                },
                {
                    name: 'کیلوگرم',
                    id: 100,
                },
            ],
            unitLiter: [
                {
                    name: 'میلی‌لیتر',
                    id: 2,

                },
                {
                    name: 'لیتر',
                    id: 101,
                },
            ],
            unitNumber: [
                {
                    name: 'عدد',
                    id: 3,

                },
            ],
            typemanagement: [
                { name: 'فاکتور خرید', id: 0 },
                { name: 'فاکتور فروش', id: 1 },
            ],
            typeParameter: [
                { name: 'نمایش همه', id: null },
                { name: 'فاکتور خرید', id: 0 },
                { name: 'فاکتور فروش', id: 1 },
            ],
            fields: [
                {
                    key: 'number',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'type',
                    label: 'نوع فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ ثبت',
                },
                {
                    key: 'sourceWarehouse',
                    label: 'انبار مبدأ',
                },
                {
                    key: 'destinationWarehouse',
                    label: 'انبار مقصد',
                },
                {
                    key: 'person',
                    label: 'شخص',
                },
                {
                    key: 'createdBy',
                    label: 'ثبت کننده',
                },
                {
                    key: 'details',
                    label: 'جزئیات',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                type: null,
                personId: null,
                sourceWarehouseId: null,
                destinationWarehouseId: null,
                fromDate: null,
                toDate: null,
            },
            parametersPeople: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersMaterials: {
                pageIndex: 1,
                pageSize: 90,
            },
            parametersWarehouses: {
                pageIndex: 1,
                pageSize: 90,
            },
            storeId: null,
            formItems: [{
                rawMaterial: null,
                quantity: null,
                unitPrice: null,
                displayUnit: null,

            }],
            form: {
                type: null,
                externalInvoiceCode: null,
                date: null,
                tax: 0,
                shipping: null,
                discount: null,
                personId: null,
                items: [],
                description: null,
                sourceWarehouseId: null,
                destinationWarehouseId: null,
            },
            invoiceId: null,
            invoiceModemanagement: [
                { name: 'عادی', id: 0 },
                { name: 'جابجایی بین دو انبار', id: 1 },
            ],
            invoiceMode: 0,
        }
    },
    methods: {
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        deleteRawMaterialItems(value) {
            this.formItems = this.formItems.filter(item => item !== value)
        },
        addRawMaterialItems() {
            this.formItems.push({
                rawMaterial: null,
                quantity: null,
                unitPrice: null,
                displayUnit: null,
            })
        },
        removeFilters() {
            this.parameters.type = null
            this.parameters.personId = null
            this.parameters.sourceWarehouseId = null
            this.parameters.destinationWarehouseId = null
            this.parameters.fromDate = null
            this.parameters.toDate = null
            this.getWarehousingInvoices()
        },
        showDetails(id, index) {
            if (this.accessHandling('employee', 'warehouse_invoices_view')) {
                this.$set(this.loadingbuttons, index, true);
                storeService.getwarehousingInvoicesById(this.storeId, id).then(({ data }) => {
                    this.invoiceDetails = data
                    this.$set(this.loadingbuttons, index, false);
                    this.$bvModal.show('warehousing-invoices-detail')
                })
                    .catch((err) => {
                        this.$set(this.loadingbuttons, index, false);
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        showModalCreate() {
            if (this.accessHandling('employee', 'warehouse_invoices_create')) {
                this.invoiceMode = 0
                this.form.type = null
                this.form.externalInvoiceCode = null
                this.form.date = null
                this.form.tax = null
                this.form.shipping = null
                this.form.discount = null
                this.form.personId = null
                this.form.items = []
                this.formItems = [{
                    rawMaterial: null,
                    quantity: null,
                    unitPrice: null,
                    displayUnit: null,
                }]
                this.form.description = null
                this.form.sourceWarehouseId = null
                this.form.destinationWarehouseId = null
                this.$bvModal.show('warehousing-invoices')
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        createWarehousingInvoices() {
            this.$refs.warehousingInvoicesValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    this.form.tax = Number(this.form.tax);
                    this.form.shipping = Number(this.form.shipping);
                    this.form.discount = Number(this.form.discount);
                    this.form.items = this.formItems.map(item => ({
                        rawMaterialId: item.rawMaterial.id,
                        unitPrice: [101, 100].includes(item.displayUnit) ? Number(item.unitPrice) / 1000 : Number(item.unitPrice),
                        quantity: [101, 100].includes(item.displayUnit) ? Number(item.quantity) * 1000 : Number(item.quantity),
                        displayUnit: item.displayUnit
                    }))
                    storeService.warehousingInvoices(this.storeId, this.form).then(({ data }) => {
                        this.$refs.warehousingInvoicesValidation.reset();
                        this.$notif({ type: 'success', title: 'فاکتور با موفقیت ثبت شد' });
                        this.$bvModal.hide('warehousing-invoices')
                        this.getWarehousingInvoices()
                    })
                        .finally(() => {
                            this.loadingButton = false
                        });
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getWarehousingMaterials();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getWarehousingInvoices() {
            this.loading = true
            this.loadingbuttons = []
            storeService.getWarehousingInvoices(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.invoices = data.items
                    if (this.invoices.length) {
                        this.invoices.forEach(obj => {
                            this.loadingbuttons.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.invoices = data.items
                        if (this.invoices.length) {
                            this.invoices.forEach(obj => {
                                this.loadingbuttons.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
        getWarehousingMaterials() {
            storeService.getWarehousingMaterials(this.storeId, this.parametersMaterials).then(({ data }) => {
                this.materials = data.items
                this.getwarehousingPeople();
            })
        },
        getwarehousingPeople() {
            storeService.getwarehousingPeople(this.storeId, this.parametersPeople).then(({ data }) => {
                this.people = data.items
                this.personParameter = [...data.items]
                this.personParameter.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingWarehouses();
            })
        },
        getWarehousingWarehouses() {
            storeService.getWarehousingWarehouses(this.storeId, this.parametersWarehouses).then(({ data }) => {
                this.warehouses = data.items
                this.warehouseParameter = [...data.items]
                this.warehouseParameter.unshift({
                    id: null,
                    name: 'نمایش همه'
                })
                this.getWarehousingInvoices();
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const tomorrow = new Date();
        const today = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.currentDate = this.formatDate2(tomorrow);
        this.getCompletionStatus()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>